import React, { useState } from 'react'
import { logo, uddlogowhite } from '../../public/LoginImages/importimages'
import { Form, Link } from 'react-router-dom'
import './homepage.css'
const Navbar = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: "#2f4f4f", padding: "10px 6rem", position: 'relative' }}>
        <div>
          <a href="/">
            <img src={uddlogowhite} alt="Urban Development Department Logo" style={{ height: "50px" }} />
          </a>
        </div>
        <div className="mobile-menu-icon" onClick={toggleMobileMenu} style={{ display: 'none', cursor: 'pointer', color: '#ccd9cc' }}>
          ☰
        </div>
        <div className={`menu-items ${isMobileMenuOpen ? 'open' : ''}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', listStyle: "none", padding: 0, margin: 0 }}>
          <ul style={{ display: 'flex',alignItems:'center', gap: '1rem', listStyle: "none", padding: 0, margin: 0, flexDirection: isMobileMenuOpen ? 'column' : 'row' }}>
            <li style={{ position: "relative", display: "inline-block", cursor: "pointer", color: "#ccd9cc", padding: "10px", userSelect: "none", }}
              onClick={toggleDropdown}> माहिती {" "}
              <span style={{ display: "inline-block", transition: "transform 0.3s ease", }}>
                {isDropdownOpen ? "▲" : "▼"}
              </span>
              <ul style={{ display: isDropdownOpen ? "block" : "none", position: "absolute", top: "100%", left: 0, backgroundColor: "white",
                  listStyle: "none",  
                  padding: "10px",
                  margin: 0,
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  borderRadius: "5px",
                  minWidth: "200px",
                  zIndex: 10,
                }}
              >
                <li style={{ padding: "5px 10px" }}>
                  <a href="/Dashboard/AboutUs" style={{ textDecoration: "none", color: "black" }}>
                    विभागाविषयी
                  </a>
                </li>
                <li style={{ padding: "5px 10px" }}>
                  <a href="/Dashboard/ContactUs" style={{ textDecoration: "none", color: "black" }}>
                    अधिकारी व दूरध्वनी
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a href="/Dashboard/ShowAuctions" style={{ color: '#ccd9cc', textDecoration: 'none' }}>Registration</a>
            </li>
          </ul>
        </div>
      </nav>
      <style>{`
        @media (max-width: 768px) {
          .mobile-menu-icon {
            display: block;
          }
          .menu-items {
            display: none;
            flex-direction: column;
            position: absolute;
            top: 60px;
            right: 0;
            background: #2f4f4f;
            width: 100%;
            padding: 10px;
          }
          .menu-items.open {
            display: flex;
          }
        }
      `}</style>
    </div>
  )
}

export default Navbar
